import { SummativeTestProperties } from 'apps/web/enums/pageKey';

import FORM_KEYS from './formKeys';

const FORM_CONTENT_MAPPER_KEYS = {
  LocalSummativeTest: [
    {
      key: SummativeTestProperties.format,
      value: FORM_KEYS.format,
    },
    {
      key: SummativeTestProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: SummativeTestProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: SummativeTestProperties.topics,
      value: FORM_KEYS.topics,
    },
    {
      key: SummativeTestProperties.language,
      value: FORM_KEYS.language,
    },
  ],
  InternationalSummativeTest: [
    {
      key: SummativeTestProperties.curriculum,
      value: FORM_KEYS.curriculum,
    },
    {
      key: SummativeTestProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: SummativeTestProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: SummativeTestProperties.topics,
      value: FORM_KEYS.topics,
    },
    {
      key: SummativeTestProperties.language,
      value: FORM_KEYS.language,
    },
    {
      key: SummativeTestProperties.assessmentTypes,
      value: FORM_KEYS.assessmentTypes,
    },
  ],
  AmericanSummativeTest: [
    {
      key: SummativeTestProperties.curriculumFramework,
      value: FORM_KEYS.curriculumFramework,
    },
    {
      key: SummativeTestProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: SummativeTestProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: SummativeTestProperties.standard,
      value: FORM_KEYS.specificStandard,
    },
    {
      key: SummativeTestProperties.topics,
      value: FORM_KEYS.topics,
    },
    {
      key: SummativeTestProperties.strategies,
      value: FORM_KEYS.strategies,
    },
  ],
};

export default FORM_CONTENT_MAPPER_KEYS;
